import React, { useState, useEffect } from "react";
import AsyncSelect from "react-select/async";
import callApi from "Common/utils/apiCaller";
import { configKey } from "./config";

const MultiDropdown = ({
  handleApiChange,
  pageType,
  isMulti = false,
  name,
  value,
  type = "podcastList",
  id,
  versionData,
  disabled = false,
}) => {
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [result, setResult] = useState<any>();
  const [objValue, setObjValue] = useState<any>();

  const fetchDefaultOptions = async () => {
    try {
      const apiResponse = await callApi(`v1/${pageType}/list`, "post", {
        pageNum: 1,
        pageSize: 500,
      });

      const options = apiResponse.data?.[configKey[type]]?.map((item) => ({
        label: item.heading,
        value: item._id,
      }));

      setDefaultOptions(options || []);
    } catch (error) {
      console.error("Error fetching data for default options:", error);
      setDefaultOptions([]);
    }
  };

  useEffect(() => {
    fetchDefaultOptions();
  }, [type, pageType]);

  const fetchOptions = async (inputValue) => {
    if (!inputValue) return [];

    let filters = { qtext: inputValue };

    try {
      // Make a single API call
      const apiResponse = await callApi(`v1/${pageType}/list`, "post", {
        pageNum: 1,
        pageSize: 50,
        filters,
      });

      const options = apiResponse.data?.[configKey[type]]?.map((item) => ({
        label: item.heading,
        value: item._id,
      }));

      return options || [];
    } catch (error) {
      console.error("Error fetching data from API:", error);
      return [];
    }
  };
  useEffect(() => {
    let res = {};
    let result = {};
    if (versionData?.value) {
      res = {
        label: defaultOptions?.find(
          (item) => item?.value === versionData?.value
        )?.label,
        value: versionData?.value,
      };
    }
    setResult(res);
    if (value?.value) {
      result = {
        label: defaultOptions?.find((item) => item?.value === value?.value)
          ?.label,
        value: value?.value,
      };
    }
    setObjValue(result);
  }, [versionData, value]);

  return (
    <>
      <div className="my-2">
        {versionData ? (
          <AsyncSelect
            isDisabled={true}
            cacheOptions
            isMulti={isMulti}
            loadOptions={fetchOptions}
            onChange={(e) => handleApiChange(name, e)}
            placeholder="Search..."
            value={result}
            //defaultOptions={result}
            id={id}
          />
        ) : null}
      </div>
      <AsyncSelect
        isDisabled={disabled}
        cacheOptions
        isMulti={isMulti}
        loadOptions={fetchOptions}
        onChange={(e) => handleApiChange(name, e)}
        placeholder="Search..."
        value={objValue}
        defaultOptions={defaultOptions}
        id={`${id}f`}
      />
    </>
  );
};

export default MultiDropdown;
